import { Button, FormControl, FormLabel, Switch, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { CONTRACT_TYPES } from '@vy/types';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useCreatePlanContext } from '../../../../contexts/create-plan-context';
import { useVyNavigate } from '../../../../hooks/use-vy-navigate';
import { useGetContractPrerequisites } from '../create-plan-page-hooks/useGetContractPrerequisites';
import type { PlanInputForm } from './CreatePlanForm/create-plan-form-types/plan-input-form';

export const CreatePlanPageHeader: React.FC = () => {
  const {
    planPreview: { open, hide, show },
  } = useCreatePlanContext();
  const navigate = useVyNavigate();
  const contractPrerequisites = useGetContractPrerequisites();
  const { getValues } = useFormContext<PlanInputForm>();
  const formValues = getValues();

  const isParentAgreement =
    contractPrerequisites?.contractType === CONTRACT_TYPES.ParentAgreement ||
    formValues?.contractType === CONTRACT_TYPES.ParentAgreement;

  const handlePlanPreviewSwitch = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    if (checked) {
      show();
    } else {
      hide();
    }
  };

  return (
    <header className="border-b-[#0D1B271F] relative flex items-center justify-between border-b py-4 px-6">
      <Button size="medium" variant="contained" color="secondary" onClick={() => navigate(-1)}>
        Close
        <VyIcon
          icon="CloseBig"
          style={{
            transform: 'scale(0.8)',
            marginRight: '-10px',
          }}
        />
      </Button>
      {!isParentAgreement && (
        <FormControl className="flex flex-row items-center gap-x-2">
          <FormLabel htmlFor="plan-preview-switch">
            <Typography variant="body1" sx={{
              color: "text.primary"
            }}>
              See Preview
            </Typography>
          </FormLabel>
          <Switch id="plan-preview-switch" checked={open} onChange={handlePlanPreviewSwitch} />
        </FormControl>
      )}
    </header>
  );
};
